var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bgBox"},[_c('div',[_vm._v("HI，欢迎登录")]),_vm._v(" "),_c('div',{staticClass:"last"},[_vm._v("达能业务管理平台")]),_vm._v(" "),_c('img',{attrs:{"src":_vm.logoURL,"alt":"homepage"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b2c39438","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/homepage/homepage.vue
// module id = null
// module chunks = 